export default {
  title: 50,
  subtitle: 150,
  paragraph: 1500,
  additional: 150,
};
